<script>
import store from '@/components/facet/store'
import tracking from '@/helpers/tracking'
import pageRefresh from '@/components/facet/page-refresh'
import isMobile from '@/lib/is-mobile'

export default {
  props: {
    model: {
      type: Object,
      required: true
    },
    excludedUid: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      store
    }
  },
  computed: {
    isSelected() {
      const { uid } = this.model
      const { tagUids } = this.store.getters
      if (tagUids.indexOf(uid) > -1) {
        return true
      }
      return false
    }
  },
  methods: {
    addTag() {
      if (!this.isSelected) {
        const { model } = this
        const { excludedUid } = this
        const tag = {
          ...model
        }

        const addItemToStart = isMobile()
        const { currentTagsAndTerms: currentFilters } = store.getters
        tracking.selectFilter({
          currentFilters,
          filterName: tag.name,
          placement: 'filter menu'
        })
        store.dispatch('addTag', { tag, excludedUid, addItemToStart })
        pageRefresh.updatePage()
      }
    },
    removeTag() {
      const { uid } = this.model
      const tag = this.store.state.tags.find((t) => t.uid === uid)
      const { currentTagsAndTerms: currentFilters } = store.getters
      tracking.removeFilter({
        currentFilters,
        filterName: tag.name,
        placement: 'filter menu'
      })
      this.store.dispatch('removeTag', { tag })
      pageRefresh.updatePage()
    }
  },
  render() {
    return this.$scopedSlots.default({
      removeTag: this.removeTag,
      addTag: this.addTag,
      isSelected: this.isSelected
    })
  }
}
</script>
